import React, { memo, useCallback, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { useFormik } from 'formik'
import { message, Upload, Button, Popconfirm, Tooltip, Tag } from 'antd'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import {
  ASSIGNEE_TYPE,
  DIGITAL_SIGN_PROVIDER,
  DIGITAL_TYPE_SIGN_SYSTEM,
  DOCUMENT_TYPE,
} from '../../constants'
import AuthoritiesActionModal from './AuthoritiesActionModal'
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from './InternalDocumentOutgoingDocCreatePageStyled'
import {
  DeleteOutlined,
  FileTextOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import utils from '../../utils'
import { toJS } from 'mobx'
import PopupRenameFile from '../../components/PopupRenameFile/PopupRenameFile'
import * as yup from 'yup'
import { useParams } from 'react-router-dom'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import { AiOutlineUser } from 'react-icons/ai'
import { AvatarHasName } from '../../components/common/Avatar'
import { SelectList } from '../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled'

const InternalDocumentOutgoingOutgoing = props => {
  const {
    open,
    handleClose,
    authorityStore,
    bookStore,
    loadingAnimationStore,
    fileStore,
    signedDocumentStore,
    internalDocumentStore,
    authenticationStore,
    companyStore,
    createMessage,
    selectPeopleStore,
  } = props
  const { authorityIssuedsList } = authorityStore
  const [fileList, setFileList] = useState([])
  const { bookGroupList, bookListOfGroup } = bookStore
  const {
    getInternalDocumentOutgoingById,
    selectedInternalDocumentOutgoing,
    updateInternalDocument,
  } = internalDocumentStore
  // console.log(
  //   "selectedInternalDocumentOutgoing",
  //   selectedInternalDocumentOutgoing
  // );
  const { documentId } = useParams()
  const [attachmentsMessage, setAttachmentsMessage] = useState(false)
  const { currentUser } = authenticationStore
  const { companyList } = companyStore
  const {
    handleOpenSelectUserDepartmentPopup,
    selectUserData,
    handleCancelSelectUserDepartment,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
  } = selectPeopleStore

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      update_type: 'OUTGOING',
      authority_issued_id:
        selectedInternalDocumentOutgoing.authority_issued_id?.id,
      book_group_id: selectedInternalDocumentOutgoing.book_group_id,
      book_id: selectedInternalDocumentOutgoing.book_id,
      company_code_recipients: {
        remove_items: [],
        new_items: [],
      },
      date_issued: selectedInternalDocumentOutgoing.date_issued,
      document_number: selectedInternalDocumentOutgoing.document_number,
      document_type: selectedInternalDocumentOutgoing.document_type,
      attachments: {
        remove_items: [],
        new_items: [],
      },
      sign_date: selectedInternalDocumentOutgoing.sign_date,
      signer: selectedInternalDocumentOutgoing.signer,
      title: selectedInternalDocumentOutgoing.title,
      urgency_level: selectedInternalDocumentOutgoing.urgency_level,
      agency_issued: selectedInternalDocumentOutgoing.agency_issued,
    },
    validationSchema: yup.object().shape({
      document_number: yup
        .string()
        .required('Vui lòng nhập số hiệu!')
        .matches(/^(?=.*\S).+$/, 'Vui lòng nhập số hiệu!'),
      title: yup
        .string()
        .required('Vui lòng nhập trích yếu!')
        .matches(/^(?=.*\S).+$/, 'Vui lòng nhập trích yếu!'),
    }),
    onSubmit: async values => {
      if (fileList.length === 0 && fileListUpdate.length === 0) {
        setAttachmentsMessage(true)
      } else {
        try {
          loadingAnimationStore.showSpinner(true)
          await updateInternalDocument(documentId, values)
          loadingAnimationStore.showSpinner(false)
          // console.log('values:', values)
          createMessage('Cập nhật văn bản thành công!', true, 'success')
        } catch (err) {
          // console.log(err)
        } finally {
          getInternalDocumentOutgoingById(documentId)
          handleCloseForm()
        }
      }
    },
  })

  // console.log('check', inter)

  useEffect(() => {
    getInternalDocumentOutgoingById(documentId)
    companyStore.getCompanyList()
  }, [])

  useEffect(() => {
    if (open) setFileListUpdate(selectedInternalDocumentOutgoing.attachments)
  }, [open, selectedInternalDocumentOutgoing])

  const handleSelectBookGroupId = async bookGroupId => {
    if (!bookGroupId) createMessage('Chưa có nhóm sổ văn bản!', true, 'warning')
    formik.setFieldValue('book_group_id', bookGroupId)
    loadingAnimationStore.showSpinner(true)
    try {
      const bookListOfGroup = await bookStore.getBookByBookGroupId(bookGroupId)
      formik.setFieldValue('book_id', bookListOfGroup.data[0].id)
    } catch (error) {
      createMessage(error?.vi, true, 'error')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleSelectBookId = bookId => {
    if (!bookId) createMessage('Chưa có sổ văn bản!', true, 'warning')
    formik.setFieldValue('book_id', bookId)
  }

  const [cCRUpdate, setCCRUpdate] = useState(
    selectedInternalDocumentOutgoing.company_recipients
  )
  useEffect(() => {
    setCCRUpdate(selectedInternalDocumentOutgoing.company_recipients)
  }, [])
  const [CCR, setCCR] = useState([])
  const handleChangeCCR = e => {
    formik.handleChange(e)
    const options = e.target.options
    const selectedValues = []
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value)
      }
    }
    setCCR(selectedValues)
  }

  const updateRecipients = useCallback(async () => {
    const new_items_company_code_recipients = []
    const remove_items_company_code_recipients = []
    const company_code_recipients_update =
      selectedInternalDocumentOutgoing.company_recipients
        ? [...toJS(selectedInternalDocumentOutgoing.company_recipients)]
        : []
    CCR.forEach(company => {
      if (
        !company_code_recipients_update.map(el => el.code).includes(company)
      ) {
        new_items_company_code_recipients.push(company)
      }
    })
    company_code_recipients_update.forEach(company => {
      if (!CCR.includes(company.code)) {
        remove_items_company_code_recipients.push(company.code)
      }
    })
    formik.setFieldValue('company_code_recipients', {
      new_items: new_items_company_code_recipients,
      remove_items: remove_items_company_code_recipients,
    })
  }, [selectedInternalDocumentOutgoing.company_recipients, CCR])

  const [fileListUpdate, setFileListUpdate] = useState([])

  const updateAttachments = useCallback(async () => {
    const fileSignedList = fileList
      .filter(file => file.isSigned)
      .map(file => file.id)
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const response = await Promise.all(batchUploadArr)
    const new_items = []
    const remove_items = []
    const originFiles = toJS(selectedInternalDocumentOutgoing.attachments)?.map(
      file => file.id
    )
    const afterFiles = [
      ...response.map(el => el.data.file_id),
      ...fileListUpdate.map(el => el.id),
      ...fileSignedList,
    ]
    afterFiles?.forEach(el => {
      if (!originFiles?.includes(el)) {
        new_items.push(el)
      }
    })
    originFiles?.forEach(el => {
      if (!afterFiles?.includes(el)) {
        remove_items.push(el)
      }
    })
    formik.setFieldValue('attachments', {
      new_items: new_items,
      remove_items: remove_items,
    })
  }, [fileList, fileListUpdate])

  const handleRemoveFileUpdate = useCallback(
    file_id => {
      const newFileList = fileListUpdate.filter(file => file.id !== file_id)
      setFileListUpdate(newFileList)
    },
    [fileListUpdate]
  )

  useEffect(() => {
    updateRecipients()
    updateAttachments()
  }, [updateRecipients, updateAttachments])

  const [advanceFilterSignD, setAdvanceFilterSignD] = useState({
    date_by: null,
    month: '',
    tag: [],
  })

  const [advanceFilterDI, setAdvanceFilterDI] = useState({
    date_by: null,
    month: '',
    tag: [],
  })

  const handleChangeSignDate = value => {
    setAdvanceFilterSignD({
      ...advanceFilterSignD,
      month: value,
    })
    formik.setFieldValue('sign_date', value)
  }

  const handleChangeDateIssued = value => {
    setAdvanceFilterDI({
      ...advanceFilterDI,
      month: value,
    })
    formik.setFieldValue('date_issued', value)
  }

  const [selectedOption, setSelectedOption] = useState(null)
  useEffect(() => {
    setSelectedOption(selectedInternalDocumentOutgoing.urgency_level)
  }, [selectedInternalDocumentOutgoing])
  const handleSelectChange = e => {
    setSelectedOption(e.target.value)
  }
  const handleClear = () => {
    setSelectedOption('')
  }

  useEffect(() => {
    if (open) {
      ;(async () => {
        loadingAnimationStore.showSpinner(true)
        try {
          authorityStore.setAuthorityIssuedsQueryParams({
            type: DOCUMENT_TYPE.OUTGOING,
            key: null,
          })
          await authorityStore.getAuthorityIssueds()
          await bookStore.getBookGroup('DI')
          await bookStore.getBookByBookGroupId(
            selectedInternalDocumentOutgoing.book_group_id
          )
        } catch (err) {
          // createMessage(err?.vi || 'Đã có lỗi xảy ra!', true, 'error')
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      })()
      return () => {
        bookStore.clearStore()
        signedDocumentStore.clearFilePDFSign()
      }
    }
  }, [open, selectedInternalDocumentOutgoing.book_group_id])

  const [isVisibleAuthoritiesActionModal, setIsVisbleAuthoritiesActionModal] =
    useState(false)

  const handleToggleAuthoritiesActionModal = bool => event => {
    setIsVisbleAuthoritiesActionModal(bool)
  }

  useEffect(() => {
    if (
      selectedOption === '' ||
      selectedOption === undefined ||
      selectedOption === null
    )
      formik.setFieldValue('urgency_level', null)
    else formik.setFieldValue('urgency_level', selectedOption)
  }, [selectedOption])

  const handleCloseForm = () => {
    handleClose()
    formik.resetForm()
    setSelectedOption(selectedInternalDocumentOutgoing.urgency_level)
    setFileList([])
    selectPeopleStore.clearSelected()
    setAttachmentsMessage(false)
  }

  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      formik.setFieldValue('file_upload', undefined)
      setFileList([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleRemoveFileFromUploadList = useCallback(
    fileUID => {
      const newFileList = fileList.filter(file => file.uid !== fileUID)
      setFileList(newFileList)
      if (newFileList.length === 0) {
        formik.setFieldValue('attachments', [])
      }
    },
    [fileList]
  )

  const [dataSignSavis, setDataSignSavis] = useState()

  const handleSignSavis = (file, index) => {
    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', file.originFileObj)
    fileStore
      .uploadFile(formData)
      .then(res => {
        const dataSubmit = {
          image: '',
          reason: 'Signed',
          location: 'VietNam',
          provider: DIGITAL_SIGN_PROVIDER,
          contactInfo: '',
          type: DIGITAL_TYPE_SIGN_SYSTEM,
          isVisible: 1,
          page: 1,
          llx: 0,
          lly: 790,
          urx: 300,
          ury: 750,
          listSignFile: [
            {
              fileId: res.data.file_id,
            },
          ],
        }
        signedDocumentStore
          .signDocumentSavis(dataSubmit)
          .then(res => {
            const { fileSignId, fileOriginName, fileSignName } =
              res.data.listSignFile[0]
            const newFileList = [...fileList]
            newFileList[index] = {
              name: fileSignName,
              id: fileSignId,
              uid: file.uid,
              isSigned: true,
              type: 'application/pdf',
            }
            setFileList(newFileList)
            loadingAnimationStore.showSpinner(false)
            createMessage(
              `Văn bản "${fileOriginName}" đã được kí`,
              true,
              'success'
            ).then()
          })
          .catch(err => {
            loadingAnimationStore.showSpinner(false)
            return createMessage(err?.vi || 'Ký số thất bại!', true, 'error')
          })
      })
      .catch(() => loadingAnimationStore.showSpinner(false))
  }

  const handleBeforeSign = (file, index) => {
    setDataSignSavis({
      file: file,
      index: index,
    })
  }

  const [fileExt, setFileExt] = useState(undefined)
  const [fileTargetRename, setFileTargetRename] = useState(null)
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false)
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false)
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.name),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.name))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }

  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }

  const submitRenameFile = async value => {
    const index = fileTargetRename?.index

    // Đổi tên file update
    if (isRenameFileUpdate) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      )
      const fileUpdateAfterRename = [...fileListUpdate]
      fileUpdateAfterRename[index].name = value.rename + fileExt
      setFileListUpdate(fileUpdateAfterRename)
      setIsModalVisibleRenameFile(false)
      createMessage('Đổi tên file thành công', true, 'success')
      return
    }
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      )
      setFileList(newFileList)
      setIsModalVisibleRenameFile(false)
      createMessage('Đổi tên file thành công', true, 'success')
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      )
      setIsModalVisibleRenameFile(false)
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      setFileList(newFileList)
      createMessage('Đổi tên file thành công', true, 'success')
    }
  }

  const renderListFileUpdate =
    fileListUpdate &&
    fileListUpdate.map((file, index) => (
      <UploadFileListItem key={file.id}>
        <FileTextOutlined style={{ color: '#1890FF' }} />
        <span style={{ color: '#1890FF' }}>{file.name}</span>
        <Button
          className={'rename'}
          type="text"
          onClick={() => {
            setIsRenameFileUpdate(true)
            handleOpenPopupRenameFile(file, index)
          }}>
          Đổi tên
        </Button>
        <Tooltip title={'Xoá tập tin'}>
          <DeleteOutlined
            onClick={() => handleRemoveFileUpdate(file.id, index)}
          />
        </Tooltip>
      </UploadFileListItem>
    ))

  const renderListFile = fileList.map((file, index) => (
    <UploadFileListItem
      key={file.uid || file.id}
      isSigned={file.isSigned}
      isNotPDF={file.type !== 'application/pdf'}>
      <FileTextOutlined />
      <span>{file.name}</span>
      {file.isSigned ? (
        <Button
          className={'digital-signature'}
          type="text"
          onClick={() => createMessage('Đã ký!', true, 'info')}>
          Đã ký
        </Button>
      ) : file.type !== 'application/pdf' ? (
        // <AccessControlAction aclActionType={ACL_ACTION_TYPE.ky_so__INCOMING}>
        <Button
          className={'digital-signature'}
          type="text"
          onClick={() =>
            createMessage(
              'Chỉ ký được file PDF, vui lòng chọn file khác!',
              true,
              'info'
            )
          }>
          Ký số
        </Button>
      ) : (
        // </AccessControlAction>
        // <AccessControlAction aclActionType={ACL_ACTION_TYPE.ky_so__INCOMING}>
        <Popconfirm
          placement="top"
          title={'Hãy chọn loại ký'}
          cancelText="Ký mặc đinh"
          onCancel={() => handleSignSavis(file, index)}>
          <Button
            className={'digital-signature'}
            type="text"
            onClick={() => handleBeforeSign(file, index)}>
            Ký số
          </Button>
        </Popconfirm>
        // </AccessControlAction>
      )}
      {
        <Button
          className={'rename'}
          type="text"
          onClick={() => {
            setIsRenameFileUpdate(false)
            handleOpenPopupRenameFile(file, index)
          }}>
          Đổi tên
        </Button>
      }
      <Tooltip title={'Xoá tập tin'}>
        <DeleteOutlined
          onClick={() => handleRemoveFileFromUploadList(file.uid, index)}
        />
      </Tooltip>
    </UploadFileListItem>
  ))

  useEffect(() => {
    if (fileList.length === 0 && fileListUpdate.length === 0)
      setAttachmentsMessage(true)
    else setAttachmentsMessage(false)
  }, [fileList, fileListUpdate])

  const [warningSH, setWarningSH] = useState({})

  const validateDocumentNumber = async e => {
    formik.handleChange(e)
    if (e.target.value && e.target.value.trim() === '') {
      return Promise.reject('Cần nhập ký tự, vui lòng không bỏ trống')
    } else {
      try {
        const response = await internalDocumentStore.getWarningDocumentNumber(
          e.target.value,
          'OUTGOING'
        )
        if (response.data.status === 'WARNING') {
          setWarningSH(response.data)
          return Promise.reject(response.data.message)
        } else {
          setWarningSH(response.data)
          return Promise.resolve()
        }
      } catch (error) {
        // console.log(error)
        createMessage(error?.vi || 'Đã có lỗi xảy ra!', true, 'error')
      }
    }
  }

  const [signerDoc, setSignerDoc] = useState([])

  useEffect(() => {
    setSignerDoc([...selectUserData[ASSIGNEE_TYPE.SIGNER]])
    if (selectUserData[ASSIGNEE_TYPE.SIGNER] !== null) {
      if (selectUserData[ASSIGNEE_TYPE.SIGNER].length > 0)
        setCheckOldSigner(false)
    }
  }, [selectUserData])

  const updateAssignees = useCallback(() => {
    const newAssignees = [...signerDoc].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    // formik.setFieldValue("signer", signerDoc ? signerDoc[0]?.full_name : null);
    formik.setFieldValue('assign_user', {
      assignees: newAssignees,
    })
  }, [signerDoc])

  useEffect(() => {
    updateAssignees()
  }, [updateAssignees])

  const [checkOldSigner, setCheckOldSigner] = useState(false)

  useEffect(() => {
    if (selectedInternalDocumentOutgoing?.signer != null) {
      setCheckOldSigner(true)
    }
  }, [])

  return (
    <Dialog
      open={open}
      onClose={handleCloseForm}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw',
            mx: 0,
            zIndex: 50,
          },
        },
      }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff]"
          sx={{
            fontWeight: 700,
            backgroundColor: '#2C65AC',
          }}>
          <span className="font-bold">Chỉnh sửa văn bản đi</span>
        </DialogTitle>
        <DialogContent>
          <div>
            <FormControl variant="standard" sx={{ mt: 1, minWidth: '100%' }}>
              <InputLabel>
                <span
                  style={{
                    display: 'inline-block',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontFamily: 'SimSun,sans-serif',
                    lineHeight: 1,
                  }}>
                  *
                </span>
                <span> Nhóm sổ văn bản</span>
              </InputLabel>
              <Select
                name="book_group_id"
                sx={{ width: '100%' }}
                value={formik.values?.book_group_id}
                onChange={event => {
                  const bookId = event.target.value
                  handleSelectBookGroupId(bookId)
                }}
                label="Nhóm sổ văn bản">
                {bookGroupList.map(book => (
                  <MenuItem key={book.id} value={book.id}>
                    {book.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <FormControl
              variant="standard"
              sx={{ mt: 1, mb: 1, minWidth: '100%' }}>
              <InputLabel>
                <span
                  style={{
                    display: 'inline-block',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontFamily: 'SimSun,sans-serif',
                    lineHeight: 1,
                  }}>
                  *
                </span>
                <span> Sổ văn bản</span>
              </InputLabel>
              <Select
                name="book_id"
                sx={{ width: '100%' }}
                value={formik.values?.book_id}
                onChange={event => {
                  const bookId = event.target.value
                  handleSelectBookId(bookId)
                }}
                label="Sổ văn bản">
                {bookListOfGroup.map(book => (
                  <MenuItem key={book.id} value={book.id}>
                    {book.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: 1 }}>
            <TextField
              name="document_number"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Số hiệu</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: 'center', height: '50px', width: '100%' }}
              value={formik.values?.document_number}
              onChange={e => {
                validateDocumentNumber(e)
              }}
              error={
                (formik.errors.document_number &&
                  formik.touched.document_number) ||
                warningSH?.status === 'WARNING'
                  ? true
                  : false
              }
            />
          </div>
          {warningSH?.status === 'WARNING' && (
            <span style={{ color: 'red' }}>
              Số hiệu văn bản đã sử dụng, vui lòng nhập số hiệu khác!
            </span>
          )}
          <div>
            <FormControl
              variant="standard"
              sx={{ mt: 1, mb: 1, minWidth: '100%' }}>
              <InputLabel>
                <span
                  style={{
                    display: 'inline-block',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontFamily: 'SimSun,sans-serif',
                    lineHeight: 1,
                    marginTop: warningSH?.status === 'WARNING' && '10px',
                  }}>
                  *
                </span>
                <span> Loại văn bản</span>
              </InputLabel>
              <Select
                name="document_type"
                sx={{ width: '100%' }}
                value={formik.values?.document_type}
                onChange={formik.handleChange}
                label="Loại văn bản">
                <MenuItem value={'021'}>Công văn</MenuItem>
                <MenuItem value={'022'}>Quyết định</MenuItem>
                <MenuItem value={'024'}>Tờ trình</MenuItem>
                <MenuItem value={'020'}>Báo cáo</MenuItem>
                <MenuItem value={'025'}>Khác</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: '8px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="sign_date"
                label={
                  <>
                    <span> Ngày ký</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                value={formik.values?.sign_date}
                onChange={handleChangeSignDate}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: '12px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="date_issued"
                label={
                  <>
                    <span> Ngày ban hành</span>
                  </>
                }
                openTo="day"
                // views={["day", "month", "year"]}
                value={formik.values?.date_issued}
                onChange={handleChangeDateIssued}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div>
            <FormControl
              variant="outlined"
              sx={{ mt: '14px', minWidth: '100%' }}>
              <InputLabel>
                <>
                  <span> Độ khẩn</span>
                </>
              </InputLabel>
              <Select
                name="urgency_level"
                sx={{ width: '100%' }}
                onChange={handleSelectChange}
                label="Độ khẩn"
                value={selectedOption}>
                <MenuItem value={''}>Bỏ chọn độ khẩn</MenuItem>
                <MenuItem value={'001'}>Khẩn</MenuItem>
                <MenuItem value={'002'}>Hỏa tốc</MenuItem>
                <MenuItem value={'003'}>Hỏa tốc hẹn giờ</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: '14px' }}>
            <TextField
              name="title"
              id="outlined-multiline-static"
              label={
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Trích yếu</span>
                </>
              }
              multiline
              rows={3}
              // variant="filled"
              sx={{ width: '100%' }}
              value={formik.values?.title}
              onChange={formik.handleChange}
              error={formik.errors.title && formik.touched.title ? true : false}
            />
          </div>
          <div style={{ marginTop: '10px' }}>
            <Upload
              valuePropName={'fileList'}
              fileList={fileList}
              multiple={true}
              beforeUpload={() => false}
              onChange={handleChangeFile}
              showUploadList={false}>
              <Button
                danger={
                  formik.errors.attachments && formik.touched.attachments
                    ? true
                    : false
                }
                style={{
                  color:
                    formik.errors.attachments && formik.touched.attachments
                      ? null
                      : '#fff',
                  backgroundColor:
                    formik.errors.attachments && formik.touched.attachments
                      ? null
                      : '#1677ff',
                  fontSize: '15px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                icon={<UploadOutlined />}>
                <>
                  <span>Chọn tài liệu đính kèm </span>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '18px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                </>
              </Button>
            </Upload>
          </div>
          {
            <UploadFileListWrapper>
              {renderListFile}
              {renderListFileUpdate}
            </UploadFileListWrapper>
          }
          {/* <div style={{ display: "flex" }}>
            <label style={{ margin: "5px" }}>Người ký:</label>
            <div>
              <Button
                style={{
                  color: "#ffb100",
                  margin: "5px",
                  border: "1px solid blue",
                }}
                onClick={() =>
                  handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.SIGNER)
                }
              >
                <AiOutlineUser />
              </Button>
              <div>
                {checkOldSigner ? (
                  <SelectList>
                    <Tag className={"tag-selected"} color={"blue"}>
                      <AvatarHasName
                        size={22}
                        name={selectedInternalDocumentOutgoing?.signer}
                      />
                    </Tag>
                  </SelectList>
                ) : (
                  <>
                    {signerDoc?.map((el) => (
                      <SelectList>
                        <Tag
                          className={"tag-selected"}
                          color={"blue"}
                          key={el.id}
                          onClick={() =>
                            selectPeopleStore.handleRemoveSelect(el)
                          }
                        >
                          <AvatarHasName
                            imgId={el.image_id}
                            size={22}
                            name={el.full_name}
                          />
                        </Tag>
                      </SelectList>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div> */}
          <div style={{ marginTop: '12px' }}>
            <TextField
              name="signer"
              id="outlined-multiline-static"
              label=" Người ký"
              // variant="filled"
              sx={{ width: '100%' }}
              value={formik.values?.signer}
              onChange={formik.handleChange}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <FormControl variant="outlined" sx={{ mt: '12px', width: '100%' }}>
              <InputLabel>
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Thông tin nơi nhận</span>
                </>
              </InputLabel>
              <Select
                name="authority_issued_id"
                sx={{ width: '100%' }}
                defaultValue={formik.values?.authority_issued_id}
                onChange={formik.handleChange}
                label="Thông tin nơi nhận">
                {authorityIssuedsList.map(authorityIssued => (
                  <MenuItem key={authorityIssued.id} value={authorityIssued.id}>
                    {authorityIssued.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              style={{
                color: '#fff',
                backgroundColor: '#1677ff',
                marginTop: '12px',
                marginLeft: '5px',
                width: '91px',
                height: '56px',
              }}
              onClick={handleToggleAuthoritiesActionModal(true)}>
              <span style={{ fontSize: '15px' }}>Tạo mới</span>
            </Button>
          </div>
          <div style={{ marginTop: '14px' }}>
            <TextField
              name="agency_issued"
              id="outlined-multiline-static"
              label={
                <>
                  <span> Nhập thông tin nơi nhận</span>
                </>
              }
              multiline
              rows={3}
              // variant="filled"
              sx={{ width: '100%' }}
              value={formik.values?.agency_issued}
              onChange={formik.handleChange}
            />
          </div>
          {/* <div>
            <label style={{ margin: '5px' }}>Nhận ngoài cơ quan:</label>
            <div
              style={{
                height: '40px',
                width: '100%',
              }}>
              <select
                name="company_code_recipients"
                style={{
                  height: '100%',
                  width: '100%',
                  WebkitAppearance: 'none',
                  padding: '5px',
                  outline: 'none',
                  borderRadius: '5px',
                  border: '1.5px solid #d9d9d9',
                }}
                multiple={true}
                value={cCRUpdate}
                onChange={e => handleChangeCCR(e)}>
                {currentUser?.company?.code &&
                  companyList &&
                  companyList
                    .filter(
                      company => company.code !== currentUser.company.code
                    )
                    .map(company => (
                      <option
                        name={company.name}
                        value={company.code}
                        key={company.code}>
                        {company.name}
                      </option>
                    ))}
              </select>
            </div>
          </div> */}
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: '#e3e4e9', position: 'sticky', bottom: 0 }}>
          <Button
            sx={{ fontWeight: 600 }}
            onClick={handleCloseForm}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
            ĐÓNG
          </Button>
          {warningSH?.status === 'WARNING' ? (
            <button
              disabled={true}
              sx={{ fontWeight: 600 }}
              className="opacity-[0.3] uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Cập nhật
            </button>
          ) : (
            <button
              type="submit"
              sx={{ fontWeight: 600 }}
              className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Cập nhật
            </button>
          )}
        </DialogActions>
      </form>
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
      {isVisibleAuthoritiesActionModal && (
        <AuthoritiesActionModal
          disabledAuthoritiesTypePicker
          tabActive={DOCUMENT_TYPE.OUTGOING}
          payloadModal={{
            status: true,
            isCreate: true,
            updatePayLoad: null,
          }}
          handleCloseModal={handleToggleAuthoritiesActionModal(false)}
        />
      )}
      <SelectPeoplePopup
        onlyOneUser
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
    </Dialog>
  )
}

export default memo(
  inject(
    'authorityStore',
    'bookStore',
    'loadingAnimationStore',
    'commonStore',
    'fileStore',
    'signedDocumentStore',
    'internalDocumentStore',
    'authenticationStore',
    'companyStore',
    'selectPeopleStore'
  )(observer(InternalDocumentOutgoingOutgoing))
)
